<style lang="scss" src='./Footer.scss' scoped></style> <!-- Global Style -->
<template src="./Footer.html"></template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

import { isEmpty } from "lodash";
import { setDefaultCourse, UpdateMe } from "@/api/api";

export default {
  name: "Footer",
  data() {
    return {
      tabMenuOptions: [
        { text: "home.home", url: "/dashboard", icon: "ico_home" },
        { text: "alerts.alerts", url: "/alerts", icon: "ico_alerts" },
        { text: "tasks.tasks", url: "/task-board", icon: "ico_tasks" },
        { text: "general.spotCheck", url: "/sync", icon: "ico_spot_check_device" },
        { text: "sensors.sensors", url: "/sensors", icon: "ico_gw_sensor" },
      ],
      userMenuOptions: [
        { text: "settings.profile", url: "/profile", icon: "ico_profile" },
        {
          text: "settings.changePassword",
          url: "/change-password",
          icon: "ico_phonelock",
        },
        {
          text: "settings.termsConditions",
          url: "http://www.getgroundworx.com/notices.htm",
          icon: "ico_terms",
        },
      ],
      isDefault: false,
      languages: [
        {
          image: "usa",
          value: "en",
          i18n: "lang.english",
        },
        {
          image: "newzealand",
          value: "en_nz",
          i18n: "lang.english",
        },
        {
          image: "uk",
          value: "en_uk",
          i18n: "lang.english",
        },
        {
          image: "canada",
          value: "en_ca",
          i18n: "lang.english",
        },
        {
          image: "australia",
          value: "en_au",
          i18n: "lang.english",
        },
        {
          image: 'thailand',
          value: 'en_th',
          i18n: 'lang.english'
        },
        {
          image: 'malaysia',
          value: 'en_my',
          i18n: 'lang.english'
        },
        {
          image: 'vietnam',
          value: 'en_vn',
          i18n: 'lang.english'
        },
        {
          image: 'singapore',
          value: 'en_sg',
          i18n: 'lang.english'
        },
        {
          image: 'myanmar',
          value: 'en_mm',
          i18n: 'lang.english'
        },
        {
          image: 'indonesia',
          value: 'en_id',
          i18n: 'lang.english'
        },
        {
          image: "mexico",
          value: "es",
          i18n: "lang.spanish",
        },
        {
          image: 'scotland',
          value: 'en_st',
          i18n: 'lang.english'
        },
      ],
    };
  },
  computed: {
    ...mapState(["course", "user", "userCourses", "setUser", "flag"]),
    ...mapGetters(["getCourses"]),

    courses() {
      let courses = [
        {
          value: null,
          text: this.$t("dropdowns.selectFacility"),
          selected: true,
          disabled: true,
        },
      ];
      courses = courses.concat(this.getCourses);
      return courses;
    },

    courseSelected: {
      get() {
        return this.course;
      },
      set(value) {
        if (value) {
          this.$store.commit("setCourse", value);
        }
      },
    },
  },

  methods: {
    ...mapMutations(["setCourse", "setLogged", "setFlag"]),
    ...mapActions(["closeMenu"]),
    ...mapMutations("Dashboard", ["setShowClimate"]),

    async changeLanguage(language, flag) {
      this.setFlag(flag);

      await UpdateMe({ language }, false)
        .then(async (user) => {
          let lang = '';
          switch (user.language) {
            case 'en':
            case 'en_au':
            case 'en_nz':
            case 'en_uk':
            case 'en_ca':
            case 'en_id':
            case 'en_my':
            case 'en_mm':
            case 'en_sg':
            case 'en_th':
            case 'en_vn':
            case 'en_st':
              lang = 'en';
              break;
            case 'es':
              lang = 'es';
              break;
          }

          this.$i18n.locale = lang;
          this.G_changeLanguage(language);
        })
        .finally(() => {
          // this.loading.lang = false;
        });
    },

    async signOut() {
      let language = "en";
      this.$i18n.locale = language;

      this.G_changeLanguage(language);
      let flag = localStorage.getItem('flag');
      this.G_signout();
      localStorage.setItem('flag', flag);
    },

    close() {
      this.setShowClimate(false);
      this.closeMenu();
    },

    signed() {
      if (!isEmpty(this.user)) {
        this.setLogged(true);
        if (isEmpty(this.course)) {
          let defaultCourse = null;
          userCourses.find((course) => {
            if (user.default_course_id == course.course_id) {
              defaultCourse = course;
            }
          });
          defaultCourse = defaultCourse ? defaultCourse : data.courses[0];

          this.course = defaultCourse ? defaultCourse : data.courses[0];
        }
      }
    },
    changeCourse(courseSelected) {
      if (courseSelected) {
        this.setCourse(courseSelected);
        this.checkDefault();
      }
    },

    checkDefault() {
      this.isDefault =
        this.user.default_course_id == this.course.course_id ? true : false;
    },

    async setCourseAsDefault() {
      if (!this.isDefault) {
        await setDefaultCourse(this.course.course_id).then((res) => {
          this.user.default_course_id = this.course.course_id;
          this.checkDefault();
        });
      }
    },
  },
  mounted() {
    this.signed();
    this.checkDefault();
  },
};
</script>